import React from 'react';

export const BookingTile = ({ active, onClick, children, className = '', testId }) => (
  <button
    type="button"
    onClick={onClick}
    data-testid={testId}
    className={`px-5 py-3 rounded-xl border-2 font-semibold text-sm transition-all ${
      active
        ? 'border-[#F56F05] bg-[#FFF7ED] text-[#F56F05]'
        : 'border-zinc-200 bg-white text-zinc-700 hover:border-zinc-300'
    } ${className}`}
  >
    {children}
  </button>
);
